import type { InputHTMLAttributes, Ref, TextareaHTMLAttributes } from "react";
import { cx } from "../cx.ts";

/** Shared look for text inputs, selects and textareas. 16 px text stops iOS zooming on focus. */
export const CONTROL_CLASSES =
  "w-full min-h-target rounded-lg border border-line-strong bg-surface px-3 text-base text-ink " +
  "placeholder:text-ink-muted disabled:cursor-not-allowed disabled:bg-surface-muted " +
  "sun:border-2 sun:border-black sun:text-min";

const INVALID = "border-danger ring-1 ring-danger sun:border-danger";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export function Input({ invalid, className, ref, type = "text", ...rest }: InputProps) {
  return (
    <input
      ref={ref}
      type={type}
      className={cx(CONTROL_CLASSES, invalid && INVALID, className)}
      {...rest}
    />
  );
}

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  ref?: Ref<HTMLTextAreaElement>;
}

export function Textarea({ invalid, className, ref, rows = 4, ...rest }: TextareaProps) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cx(CONTROL_CLASSES, "py-2", invalid && INVALID, className)}
      {...rest}
    />
  );
}
